/** Curated service → art stills for the print menu. Swap paths here while iterating. */
export const printMenuImageMap: Record<string, { src: string; alt: string }> = {
  'gel-protective-base': {
    src: '/menu/m-1.png',
    alt: 'Olive French-tip gel manicure with rose-gold glitter accents and bee charms',
  },
  'gel-structured': {
    src: '/menu/m-2.png',
    alt: 'Pearlescent almond nails with gold chain accents, pearls, and delicate rings',
  },
  'gel-x-extensions': {
    src: '/menu/m-3.png',
    alt: 'Iridescent stiletto Gel X extensions with 3D florals, pearls, and chrome finish',
  },
  'gel-x-fill': {
    src: '/menu/m-4.png',
    alt: 'Long stiletto Gel X fill with 3D white florals, gold filigree, pearls, and dried petals',
  },
  'ped-classic': {
    src: '/menu/m-1.png',
    alt: 'Salon menu photography — refined nail finish',
  },
  'ped-volcano': {
    src: '/menu/m-2.png',
    alt: 'Salon menu photography — elegant nail art detail',
  },
  'ped-milk-honey': {
    src: '/menu/m-3.png',
    alt: 'Salon menu photography — long shaped gel finish',
  },
  'ped-organic-herb': {
    src: '/menu/m-4.png',
    alt: 'Salon menu photography — premium nail art styling',
  },
  'ped-golden-glow': {
    src: '/menu/m-1.png',
    alt: 'Salon menu photography — refined nail finish',
  },
  'man-classic': {
    src: '/arts/1.jpg',
    alt: 'Almond manicure with cream, olive, and sage tones',
  },
  'man-milk-honey': {
    src: '/arts/2.jpg',
    alt: 'Soft sheer nude nails with hand-painted daisies',
  },
  'man-organic-herb': {
    src: '/arts/3.jpg',
    alt: 'Olive green manicure with floral accent nail',
  },
  'man-golden-glow': {
    src: '/arts/4.jpg',
    alt: 'Glossy almond nails with botanical art',
  },
  'combo-classic': {
    src: '/arts/11.jpg',
    alt: 'Pastel yellow almond nails with daisy nail art',
  },
  'combo-volcano': {
    src: '/arts/12.jpg',
    alt: 'Bright yellow French tips with sunflower accent nails',
  },
  'combo-milk-honey': {
    src: '/arts/20.jpg',
    alt: 'Cream glossy nails with watercolor florals',
  },
  'combo-organic-herb': {
    src: '/arts/24.jpg',
    alt: 'Glossy nails with floral-inspired details',
  },
  'combo-golden': {
    src: '/arts/30.jpg',
    alt: 'Full-set nail art with cohesive theme and professional finish',
  },
}

export function getPrintMenuImage(serviceId: string): { src: string; alt: string } {
  return (
    printMenuImageMap[serviceId] ?? {
      src: '/arts/21.jpg',
      alt: 'Elegant nail art showcase',
    }
  )
}
